const CategoryCheckbox = ({ category, onChange }) => {

      const checkHandler = () => {
        if (onChange) {
            onChange(category, !category.active);
        }
    };

    const getIconClasses = () => category.active ? 'category-checkbox-icon active' : 'category-checkbox-icon';
    const getLabelClasses = () => category.active ? 'category-checkbox-label active' : 'category-checkbox-label';
    
    return (
        <div className='category-checkbox-container'>
            <input
                id={category.value}
                type="checkbox"
                className="d-none"                
                checked={category.active}
                readOnly
            />
            <label
                htmlFor={category.value}
                className='d-flex flex-column justify-content-center align-items-center'
                onClick={checkHandler}
            >
                <div className={getIconClasses()}>{category.svg()}</div>
                <div className={getLabelClasses()}>{category.label}</div>
            </label>
        </div>
    );
};

export default CategoryCheckbox;
